module.exports = __webpack_public_path__ + "img/cartaz.0616b49d.jpg";